import _ from 'lodash';
import moment from 'moment';

const formatterNames = {
  round: 'round',
  percentage: 'percentage',
  formatDate: 'formatDate',
  length: 'length',
  gt: 'gt',
  if: 'if',
};

const formatterFunctions = {
  [formatterNames.round]: (value, decimals = 0) => {
    return _.round(value, _.toNumber(decimals));
  },
  [formatterNames.percentage]: (value) => {
    return `${_.round(value * 100)}%`;
  },
  [formatterNames.length]: (value) => {
    return value.length;
  },
  [formatterNames.formatDate]: (value, format) => {
    return moment(value).format(format);
  },
  [formatterNames.gt]: (value, threshold = 0) => {
    return value > _.toNumber(threshold);
  },
  [formatterNames.if]: (value, truthyValue, falsyValue) => {
    return value ? truthyValue : falsyValue;
  },
};

function applyFormatters(variableValue, formatters) {
  return formatters.reduce((result, { formatter, args }) => formatterFunctions[formatter](result, ...(args || [])), variableValue);
}

function parseFormatter(formatterString) {
  const parts = formatterString.split('|').map(part => part.trim());
  const variableName = parts[0];
  const formatters = parts.slice(1).map(formatterWithArgs => {
    const [formatter, argsString] = formatterWithArgs.split('(').map(str => str.trim());
    const args = argsString ? argsString.slice(0, -1).split(',').map(arg => arg.trim()) : [];
    return { formatter, args };
  });
  return { variableName: variableName, formatters: formatters };
}

export default {
  parseFormatter,
  applyFormatters,
};
